import { Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import FeatureFlag from '../common/FeatureFlag';

import { ProductInformation } from '../../types';
import UserWrapper from '../user/User';

interface Props {
    product: ProductInformation;
}

const ProductListItem = ({ product }: Props) => {
    return (
        <Table.Row>
            <Table.Cell>
                {product?.id ? (
                    <Link to={`/product/${product?.id}`}>{product.label}</Link>
                ) : (
                    product.label
                )}
            </Table.Cell>
            <FeatureFlag featureFlag="Client1Specific" showHide={false}>
                <Table.Cell>{product.reference}</Table.Cell>
                <Table.Cell>{product.classOfBusiness}</Table.Cell>
                <Table.Cell>{product.fcaCategory}</Table.Cell>
                <Table.Cell>{product.riskCode}</Table.Cell>
                <Table.Cell>{product.productGroup}</Table.Cell>
            </FeatureFlag>
            <FeatureFlag featureFlag="Client1Specific" showHide={true}>
                <Table.Cell>{product.productSegment}</Table.Cell>
                <Table.Cell>{product.productClass}</Table.Cell>
                <Table.Cell>{product.riskRatingLabel}</Table.Cell>
                <Table.Cell>{product.productOwner}</Table.Cell>
                <Table.Cell>{product.productReviewer}</Table.Cell>
                <Table.Cell>{product.archivedDisplay}</Table.Cell>
            </FeatureFlag>
        </Table.Row>
    );
};

export default UserWrapper(ProductListItem);
